<template>
  <qx-card title="列表">
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            >
              <section  slot-scope="scope">
                <section
                  v-if="scope.column.property === 'sourceRegionName'"
                  @click="toOilRecharge(scope.row.busiCode)"
                >
                  {{scope.row.sourceRegionName}}-{{scope.row.desRegionName}}
                </section>
                <section v-else>{{scope.row[scope.column.property]}}</section>
              </section>
            </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  customerOrderList,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  data () {
    return {
      totalData: {
        receiveToatlFee: 0,
        uncollectedTotalFee: 0,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'orderId',
        title: [ // 表头
          {
            prop: 'dependDate',
            label: '发车时间',
          },
          {
            prop: 'orderId',
            label: '订单号',
          },
          {
            prop: 'billNumber',
            label: '账单号码',
          },
          {
            prop: 'customName',
            label: '客户名称',
          },
          {
            prop: 'checkName',
            label: '对账名称',
          },
          {
            prop: 'customNumber',
            label: '客户回单号',
          },
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'carType',
            label: '车型',
          },
          {
            prop: 'sourceRegionName',
            label: '运输线路',
            w: '160px',
          },
          {
            prop: 'sourceName',
            label: '线路名称',
          },
          {
            prop: 'orderTypeName',
            label: '线路属性',
          },
          {
            prop: 'orgName',
            label: '归属部门',
          },
          {
            prop: 'goodsInfo',
            label: '货物信息',
          },
          {
            prop: 'carDependDate',
            label: '实际发车时间',
          },
          {
            prop: 'carStartDate',
            label: '实际离台时间',
          },
          {
            prop: 'carArriveDate',
            label: '实际到达时间',
          },
          {
            prop: 'costPriceDouble',
            label: '订单收入',
          },
          {
            prop: 'incomeExceptionFeeDouble',
            label: '异常款',
          },
          {
            prop: 'estimateIncomeFeeDouble',
            label: '订单收入合计',
          },
          {
            prop: 'diffFeeDouble',
            label: '对账调整',
          },
          {
            prop: 'affirmIncomeFeeDouble',
            label: '确认收入',
          },
          {
            prop: 'getAmountDouble',
            label: '核销金额',
          },
          {
            prop: 'realIncomeDouble',
            label: '实收',
          },
          {
            prop: 'financeStsName',
            label: '发票',
          },
          {
            prop: 'financeStsName',
            label: '核销状态',
          },
          {
            prop: 'orderStateName',
            label: '订单状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: customerOrderList,
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
